import Link from "next/link";
import SEOConfig from "@/common/seo.config";
import { Footer, Header, SEO } from "@/components";
import { LandingSection, PageHero } from "@/components/main/landing/landing-ui";
import {
  buildBreadcrumbList,
  buildWebPage,
  pageSchemas,
} from "@/lib/schema";

const SECTIONS = [
  {
    title: "Acceptance",
    body: "By using nivalabs.ai, you agree to these terms. If you do not agree, please do not use the site.",
  },
  {
    title: "Site purpose",
    body: "This website provides information about Nivalabs services and a way to contact us. Content is for general information and may change without notice.",
  },
  {
    title: "No professional advice",
    body: "Nothing on this site is legal, financial, or technical advice for your specific situation. Engagements for paid work are governed by separate agreements.",
  },
  {
    title: "Intellectual property",
    body: "Site content, branding, and materials are owned by Nivalabs or its licensors. You may not copy or reuse them without permission except for fair personal use of publicly available pages.",
  },
  {
    title: "Acceptable use",
    body: "You agree not to misuse the site, attempt unauthorized access, disrupt services, or submit unlawful or harmful content through forms.",
  },
  {
    title: "Disclaimer",
    body: "The site is provided as is. To the fullest extent permitted by law, Nivalabs disclaims warranties of accuracy, availability, and fitness for a particular purpose.",
  },
  {
    title: "Limitation of liability",
    body: "To the fullest extent permitted by law, Nivalabs is not liable for indirect or consequential damages arising from use of the site. Liability for direct damages is limited to the greatest extent allowed by applicable law.",
  },
  {
    title: "Contact",
    body: "Questions about these terms can be sent through the Contact page.",
  },
];

export default function TermsPage() {
  const structuredData = pageSchemas([
    buildWebPage({
      path: "/terms",
      name: SEOConfig.terms.pageTitle,
      description: SEOConfig.terms.pageDescription,
    }),
    buildBreadcrumbList([
      { name: "Home", path: "/" },
      { name: "Terms", path: "/terms" },
    ]),
  ]);

  return (
    <>
      <SEO {...SEOConfig.terms} structuredData={structuredData} />
      <Header />
      <main>
        <PageHero
          compact
          title="Terms of use"
          lead="Ground rules for using the Nivalabs website. Paid engagements are covered by separate contracts."
        />

        <LandingSection narrow>
          <p className="text-sm text-ink-soft">Last updated: July 30, 2026</p>
          <div className="mt-10 space-y-10">
            {SECTIONS.map((section) => (
              <div key={section.title}>
                <h2 className="text-xl font-semibold text-ink">{section.title}</h2>
                <p className="mt-3 text-base leading-relaxed text-ink-muted">
                  {section.body}
                </p>
              </div>
            ))}
          </div>
          <p className="mt-12 text-sm text-ink-muted">
            Related:{" "}
            <Link
              href="/privacy"
              className="font-semibold text-[#1c8c80] no-underline hover:underline"
            >
              Privacy
            </Link>
            {" · "}
            <Link
              href="/contact"
              className="font-semibold text-[#1c8c80] no-underline hover:underline"
            >
              Contact
            </Link>
          </p>
        </LandingSection>
      </main>
      <Footer />
    </>
  );
}
